export default "__VITE_ASSET__L9N4o3Ul__"